import React from 'react';
import { useIdleSession } from '../../hooks/useIdleSession';

/**
 * Component that handles idle session timeout
 * Should be placed inside the app but outside protected routes
 */
const IdleSessionHandler: React.FC = () => {
  // Configure idle session timeout (5 minutes)
  // You can customize this by passing options:
  // useIdleSession({ timeout: 15 * 60 * 1000 }) // 15 minutes
  
  // Auto-logout on idle session - COMMENTED OUT
  // useIdleSession({
  //   timeout: 5 * 60 * 1000, // 5 minutes in milliseconds
  //   enabled: true, // Enable idle session detection
  // });

  // This component doesn't render anything
  return null;
};

export default IdleSessionHandler;

